module.exports = __webpack_public_path__ + "static/img/israel-today.b9eb527.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/IsraelToday/israel-today.png
// module id = tLqE
// module chunks = 0